import { CHANGE_TABS, RESET_MANAGEMENT_ERROR } from './ManagementConstants'

export const reset = () => {
  const action = {
    type: RESET_MANAGEMENT_ERROR,
  }
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const changeTabs = (title) => {
  const action = {
    type: CHANGE_TABS,
    payload: title,
  }
  return action
}
